import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const RegistrationCTA = () => {
  const { isAuthenticated } = useAuth();

  // Don't show for authenticated users
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="mt-4 p-4 bg-gradient-to-r from-green-500/10 to-blue-500/10 border border-green-500/30 rounded-lg">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex-1 min-w-[200px]">
          <p className="text-sm font-semibold text-green-400 mb-1">
            🚀 Want more capacity?
          </p>
          <p className="text-xs text-gray-300">
            Register for <span className="font-bold text-white">FREE</span> to unlock <span className="font-bold text-green-400">30 videos/day</span> and <span className="font-bold text-green-400">10x hourly limit!</span>
          </p>
        </div>
        <Link 
          to="/register"
          className="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-green-500/50"
        >
          Register Now →
        </Link>
      </div>
    </div>
  );
};

export default RegistrationCTA;
